import { Skeleton } from 'antd';

// Custom data source to show skeletons inside table rows
const skeletonData = Array.from({ length: 10 }, (_, index) => ({
  index: <Skeleton active title={false} paragraph={{ rows: 1, width: "10%" }} />,
  actionByName: <><Skeleton active title={false} paragraph={{ rows: 1, width: "40%" }} /><Skeleton active title={false} paragraph={{ rows: 1, width: "80%" }} /></>,
  actionOnName: <><Skeleton active title={false} paragraph={{ rows: 1, width: "40%" }} /><Skeleton active title={false} paragraph={{ rows: 1, width: "80%" }} /></>,
  message: <Skeleton active title={false} paragraph={{ rows: 1, width: "100%" }} />,
  createdAt: <Skeleton active title={false} paragraph={{ rows: 1, width: "80%" }} />,
}));

// Exporting the skeletonData
export { skeletonData };
